import 'react';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import 'reakit/Code';
import './styled.js';
import { a as Code } from './HighlightedCode-86e2f8dc.js';
export { a as Code, e as HighlightedCode, g as codeDefaultProps, f as codePropTypes, c as highlightedCodeDefaultProps, b as highlightedCodePropTypes } from './HighlightedCode-86e2f8dc.js';
import 'react-syntax-highlighter/prism-light';
import './theme.js';
import 'react-syntax-highlighter/languages/prism/javascript';
import 'react-syntax-highlighter/languages/prism/jsx';
import 'react-syntax-highlighter/languages/prism/json';
export default Code;